import React from "react";
import {
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import styles from "./Sheets.module.css";
import { alpha } from "@mui/material/styles";

const DataTable = ({ sheet }) => {
  return (
    <TableContainer
      sx={{ backgroundColor: (theme) => theme.palette.background2 }}
    >
      <Table>
        <TableBody>
          {sheet?.map((row, rowIndex) => {
            return (
              <TableRow
                key={`row-${rowIndex}`}
                sx={{
                  borderTop: "2px solid rgba(76, 137, 145, 0.6)",
                  borderColor: (theme) =>
                    alpha(theme.palette.primary.main, 0.3),
                  "&:first-child": {
                    borderTop: "none",
                  },
                  "&:last-child": {
                    borderBottom: "2px solid white",
                  },
                  paddingLeft:50
                }}>
                {row.cells.map((cell, cellIndex) => (
                  <TableCell style={{
                    paddingLeft:50
                  }}
                    key={`cell-${rowIndex}-${cellIndex}`}
                    className={styles["cell"]}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;
